import { MarketDetectionUtil } from '~shared/utils/market-detection.util';
import { CountryCode } from '~shared/constants/country-code.enum';
import {
  LEGAL_MY_METRO_AGB_DE,
  LEGAL_COMPANION_APP_AGB_DE,
  LEGAL_METRO_MARKETS_AGB_DE,
  LEGAL_DATA_PROTECTION_DE,
  LEGAL_TERMS_AND_CONDITIONS_LINK_ES,
  CONDITION_LINK_TEXT_ES,
  HOME_LINK_TEXT_1_ES,
  LEGAL_IMPRINT_EXTERNAL_LINK_ES,
  LEGAL_PRIVACY_POLICY_LINK_ES,
  METRO_CUSTOMER_SUPPORT_DE,
  MAKRO_CUSTOMER_SUPPORT_ES,
  LEGAL_CANCELLATION_POLICY_DE,
  LEGAL_TERMS_AND_CONDITIONS_LINK_IT,
  CONDITION_LINK_TEXT_IT,
  LEGAL_PRIVACY_POLICY_LINK_IT,
  LEGAL_PRIVACY_POLICY_LINK_TEXT_IT,
  LEGAL_PRIVACY_COOKIES_LINK_IT,
  LEGAL_PRIVACY_COOKIES_LINK_TEXT_IT,
  LEGAL_TERMS_AND_CONDITIONS_LINK_PT,
  CONDITION_LINK_TEXT_PT,
  LEGAL_PRIVACY_POLICY_LINK_PT,
  LEGAL_PRIVACY_POLICY_LINK_TEXT_PT,
  LEGAL_PRIVACY_COOKIES_LINK_PT,
  LEGAL_PRIVACY_COOKIES_LINK_TEXT_PT,
  NL_BUYER_SUPPORT_TICKET_NEW_LINK,
  LEGAL_DATA_PROTECTION_NL,
  FR_BUYER_SUPPORT_TICKET_NEW_LINK,
  LEGAL_TERMS_AND_CONDITIONS_LINK_FR,
  CONDITION_LINK_TEXT_FR,
  HOME_LINK_TEXT_FR,
  METRO_LEGAL_TERMS_AND_CONDITIONS_LINK_FR,
  LEGAL_PRIVACY_POLICY_LINK_FR,
  IT_BUYER_SUPPORT_TICKET_NEW_LINK,
  PT_BUYER_SUPPORT_TICKET_NEW_LINK,
} from '~shared/constants/links.constants';

export const MULTI_MARKET_TIER1_SIGNUP_LEGAL_TEXT_PARAMS = {
  [CountryCode.Germany]: {
    MY_METRO_AGB: LEGAL_MY_METRO_AGB_DE,
    COMPANION_APP_AGB: LEGAL_COMPANION_APP_AGB_DE,
    METRO_MARKETS_AGB: LEGAL_METRO_MARKETS_AGB_DE,
    CANCELLATION_POLICY: LEGAL_CANCELLATION_POLICY_DE,
    DATA_PROTECTION: LEGAL_DATA_PROTECTION_DE,
  },
  [CountryCode.Spain]: {
    TERMS_AND_CONDITIONS_LINK: LEGAL_TERMS_AND_CONDITIONS_LINK_ES,
    CONDITION_LINK_TEXT: CONDITION_LINK_TEXT_ES,
    HOME_LINK: HOME_LINK_TEXT_1_ES,
    LEGAL_WARNING: LEGAL_IMPRINT_EXTERNAL_LINK_ES,
    LEGAL_PRIVACY_POLICY_LINK: LEGAL_PRIVACY_POLICY_LINK_ES,
  },
  [CountryCode.Italy]: {
    TERMS_AND_CONDITIONS_LINK: LEGAL_TERMS_AND_CONDITIONS_LINK_IT,
    CONDITION_LINK_TEXT: CONDITION_LINK_TEXT_IT,
    LEGAL_PRIVACY_POLICY_LINK: LEGAL_PRIVACY_POLICY_LINK_IT,
    LEGAL_PRIVACY_POLICY_LINK_TEXT: LEGAL_PRIVACY_POLICY_LINK_TEXT_IT,
    LEGAL_PRIVACY_COOKIES_LINK: LEGAL_PRIVACY_COOKIES_LINK_IT,
    LEGAL_PRIVACY_COOKIES_LINK_TEXT: LEGAL_PRIVACY_COOKIES_LINK_TEXT_IT,
  },
  [CountryCode.Portugal]: {
    TERMS_AND_CONDITIONS_LINK: LEGAL_TERMS_AND_CONDITIONS_LINK_PT,
    CONDITION_LINK_TEXT: CONDITION_LINK_TEXT_PT,
    LEGAL_PRIVACY_POLICY_LINK: LEGAL_PRIVACY_POLICY_LINK_PT,
    LEGAL_PRIVACY_POLICY_LINK_TEXT: LEGAL_PRIVACY_POLICY_LINK_TEXT_PT,
    LEGAL_PRIVACY_COOKIES_LINK: LEGAL_PRIVACY_COOKIES_LINK_PT,
    LEGAL_PRIVACY_COOKIES_LINK_TEXT: LEGAL_PRIVACY_COOKIES_LINK_TEXT_PT,
  },
  [CountryCode.Netherlands]: {
    DATA_PROTECTION: LEGAL_DATA_PROTECTION_NL,
  },
  [CountryCode.France]: {
    LEGAL_TERMS_AND_CONDITIONS_LINK: LEGAL_TERMS_AND_CONDITIONS_LINK_FR,
    CONDITION_LINK_TEXT: CONDITION_LINK_TEXT_FR,
    HOME_LINK_TEXT: HOME_LINK_TEXT_FR,
    METRO_LEGAL_TERMS_AND_CONDITIONS_LINK: METRO_LEGAL_TERMS_AND_CONDITIONS_LINK_FR,
    LEGAL_PRIVACY_POLICY_LINK: LEGAL_PRIVACY_POLICY_LINK_FR,
  },
};

export const MULTI_MARKET_TIER1_SIGNUP_EXTRA_LINKS = {
  [CountryCode.Germany]: {
    CUSTOMER_SUPPORT: METRO_CUSTOMER_SUPPORT_DE,
  },
  [CountryCode.Spain]: {
    CUSTOMER_SUPPORT: MAKRO_CUSTOMER_SUPPORT_ES,
  },
  [CountryCode.Netherlands]: {
    CUSTOMER_SUPPORT: NL_BUYER_SUPPORT_TICKET_NEW_LINK,
  },
  [CountryCode.France]: {
    CUSTOMER_SUPPORT: FR_BUYER_SUPPORT_TICKET_NEW_LINK,
  },
  [CountryCode.Italy]: {
    CUSTOMER_SUPPORT: IT_BUYER_SUPPORT_TICKET_NEW_LINK
  },
  [CountryCode.Portugal]: {
    CUSTOMER_SUPPORT: PT_BUYER_SUPPORT_TICKET_NEW_LINK
  }
};

export const TIER1_SIGNUP_LEGAL_TEXT_PARAMS = () =>
  MULTI_MARKET_TIER1_SIGNUP_LEGAL_TEXT_PARAMS[MarketDetectionUtil.getCountryCode()];

export const TIER1_SIGNUP_LEGAL_EXTRA_LINKS = () =>
  MULTI_MARKET_TIER1_SIGNUP_EXTRA_LINKS[MarketDetectionUtil.getCountryCode()];
